import AccessDenied from "components/AccessDenied/index.js";
import PageContainer from "components/PageContainer/index.js";
import { useAuth } from "contexts/auth.context";
import Footer from "examples/Footer/index.js";
import DashboardLayout from "examples/LayoutContainers/DashboardLayout";
import DashboardNavbar from "examples/Navbars/DashboardNavbar";
import AllAudits from "layouts/audits/components/AllAudits";
import Audit from "layouts/audits/components/Audit/index.js";
import { Route, Routes } from "react-router-dom";
import AllUsers from "./components/AllUsers.js";

function Users() {
  const { checkPermission } = useAuth();

  if (
    Object.keys(checkPermission("user")).filter(
      (key) => checkPermission("user")[key]
    ).length === 0
  ) {
    return <AccessDenied type="page" />;
  }

  return (
    <DashboardLayout>
      <DashboardNavbar />

      <PageContainer>
        <Routes>
          <Route
            index
            element={<AllUsers permissions={checkPermission("user")} />}
          />
          <Route path={"/:userId/audits"} element={<AllAudits />} />
          <Route path={"/:userId/audits/:id"} element={<Audit />} />
        </Routes>
      </PageContainer>

      <Footer />
    </DashboardLayout>
  );
}

export default Users;
